import { MenuOptionType } from "@dexteel/mesf-core";
import DeleteIcon from "@mui/icons-material/Delete";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import type { Inspection } from "../../models/Inspection";

type Props = {
	handleNewInspection: () => void;
	openInspection: (inspection: Inspection) => void;
	deleteInspection: (inspection: Inspection) => void;
};

export const useInspectionsOptionsFunctions = ({
	handleNewInspection,
	openInspection,
	deleteInspection,
}: Props) => {
	const getMenuOptions = (data: Inspection) => {
		const options: MenuOptionType[] = [
			{
				name: "New Inspection",
				key: "new_inspection",
				onClick: handleNewInspection,
				icon: <PlaylistAddIcon />,
			},
		];

		if (data) {
			options.push({
				name: "Open Sheet",
				key: "open_inspection",
				onClick: () => openInspection(data),
				icon: <OpenInNewIcon />,
			});
			options.push({
				name: "Delete Sheet",
				key: "delete_inspection",
				onClick: () => deleteInspection(data),
				icon: <DeleteIcon />,
				disabled: !data.IsEditable,
			});
		}

		return options;
	};

	return { getMenuOptions };
};
